import en from './en/translations.json';
import ar from './ar/translations.json';

export default { en, ar };
